<template>
  <v-layout wrap>
    <v-flex
      sm6
      md4
    >
      <v-text-field
        v-model="currentUser.id"
        label="User ID"
        disabled
      />
    </v-flex>
    <v-flex
      sm6
      md4
    >
      <v-text-field
        v-model="currentUser.first_name"
        label="First name"
        disabled
      />
    </v-flex>
    <v-flex
      sm6
      md4
    >
      <v-text-field
        v-model="currentUser.last_name"
        label="Last name"
        disabled
      />
    </v-flex>
    <v-flex
      xs12
      md4
    >
      <label class="radio-label">Ident Provider</label>
      <v-radio-group
        v-model="formData.provider"
        row
        :error-messages="getFieldErrors('provider')"
        @change="$v.formData.provider.$touch()"
        @blur="$v.formData.provider.$touch()"
      >
        <v-radio
          v-for="provider in validProviders"
          :key="provider.id"
          :value="provider.name"
          :label="provider.name"
          color="primary"
        />
      </v-radio-group>
    </v-flex>
    <v-flex
      xs6
      md4
    >
      <v-text-field
        v-model="formData.identCaseIdentifier"
        :label="getCaseIdLabel()"
        :error-messages="getFieldErrors('identCaseIdentifier')"
        @change="$v.formData.identCaseIdentifier.$touch()"
        @blur="$v.formData.identCaseIdentifier.$touch()"
      />
    </v-flex>

    <v-flex
      xs12
      md4
    >
      <v-autocomplete
        v-model="formData.regionCode"
        :items="countryCodesArray"
        :search-input.sync="countrySearch"
        item-text="name"
        item-value="value"
        label="Country"
        :error-messages="getFieldErrors('regionCode')"
        @change="$v.formData.regionCode.$touch()"
        @blur="$v.formData.regionCode.$touch()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { identProviders } from '@/enum/ident/IdentEnum';
import { countryCodesArray } from '@/enum/CountryCodesEnum';

export default {
  name: 'ImportIdentFormFields',
  props: {
    currentUser: {
      type: Object,
      default: null,
      required,
    },
    onSubmit: {
      type: Function,
      required,
      default: null,
    },
  },

  data: () => ({
    countryCodesArray,
    countrySearch: '',
    error: null,
    formData: {
      userId: null,
      identCaseIdentifier: null,
      lastName: null,
      firstName: null,
      domain: 'exporo.de',
      provider: identProviders.IDNOW,
      regionCode: null,
    },
  }),

  validations() {
    return {
      formData: {
        provider: { required },
        userId: { required },
        identCaseIdentifier: { required },
        regionCode: { required },
        lastName: { required },
        firstName: { required },
        domain: { required },
      },
    };
  },

  computed: {
    validProviders() {
      return Object.keys(this.providers)
        .map(key => this.providers[key])
        .filter(provider => provider.name !== identProviders.EXPORO);
    },
    providers() {
      return this.$store.state.identStore.providers;
    },
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
  },

  watch: {
    currentUser(user) {
      if (user) {
        return this.mapUserData();
      }

      return this.resetUserData();
    },
  },

  mounted() {
    this.mapUserData();
  },

  methods: {
    getCaseIdLabel() {
      return this.formData.provider === identProviders.IDNOW ? 'Transaction number' : 'Case id';
    },
    getFieldErrors(field) {
      const errors = [];
      if (this.$v.formData[field]) {
        if (!this.$v.formData[field].$dirty || !this.$v.formData[field].$invalid) {
          return errors;
        }
        if (!this.$v.formData[field].required) {
          errors.push('Required field');
        }
      }

      return errors;
    },
    mapUserData() {
      this.formData.userId = this.currentUser.id;
      this.formData.firstName = this.currentUser.first_name;
      this.formData.lastName = this.currentUser.last_name;

      const country = this.countryCodesArray
        // eslint-disable-next-line max-len
        .find(
          item => item.backendValue ===
            (this.currentUser.country ||
              this.currentUser.citizenship ||
              this.currentUser.country_of_birth),
        );
      this.formData.regionCode = country ? country.value : null;
    },
    resetUserData() {
      this.formData.userId = null;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.onSubmit(this.formData);
      }
    },
  },
};
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/components/ident/dialog/import/ImportIdentFormFields.vue